export { IKuiTableCol, IKuiTableRow, IKuiTableColFilterOperator, IKuiTableColFilterValue } from './table.model';
export * from './table.module';
